import { useEffect, useState } from 'react';

const ChatWidgetLoader = () => {
  const [config, setConfig] = useState(null);
  const [loaded, setLoaded] = useState(false);

  // Páginas donde ocultar el widget de chat
  const paginasOcultarWidget = ['/app/gestion-usuarios', '/app/zoom-test', '/app/clase-zoom-beta'];

  useEffect(() => {
    loadChatConfig();
  }, []);

  // Ocultar/mostrar widget según la página actual (usando window.location)
  useEffect(() => {
    const checkAndToggleWidget = () => {
      const pathname = window.location.pathname;
      const debeOcultar = paginasOcultarWidget.some(p => pathname.startsWith(p));
      
      // Ocultar Tidio
      const tidioChat = document.querySelector('#tidio-chat');
      if (tidioChat) {
        tidioChat.style.display = debeOcultar ? 'none' : 'block';
      }
      
      // Ocultar ElevenLabs
      const elevenLabsWidget = document.getElementById('elevenlabs-widget');
      if (elevenLabsWidget) {
        elevenLabsWidget.style.display = debeOcultar ? 'none' : 'block';
      }
      const dragHandle = document.getElementById('elevenlabs-drag-handle');
      if (dragHandle) {
        dragHandle.style.display = debeOcultar ? 'none' : 'flex';
      }

      // También intentar con el API de Tidio
      if (window.tidioChatApi) {
        if (debeOcultar) {
          window.tidioChatApi.hide();
        } else {
          window.tidioChatApi.show();
        }
      }
    };

    // Verificar inicialmente
    checkAndToggleWidget();

    // Verificar en cada cambio de URL (para SPA)
    const interval = setInterval(checkAndToggleWidget, 1000);

    return () => clearInterval(interval);
  }, [loaded]);

  const loadChatConfig = async () => {
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${API}/api/public/chat-widget-config`);
      
      if (!response.ok) {
        console.log('ChatWidgetLoader: No se pudo obtener configuración');
        return;
      }
      
      const data = await response.json();
      setConfig(data);
      
      // Cargar el widget correspondiente
      if (data.chat_activo === 'tidio' && data.tidio_script) {
        loadTidio(data.tidio_script);
      } else if (data.chat_activo === 'elevenlabs' && data.elevenlabs_agent_id) {
        loadElevenLabs(data.elevenlabs_agent_id);
      }
      
    } catch (error) {
      console.log('ChatWidgetLoader: Error cargando configuración', error.message);
    }
  };

  const loadTidio = (scriptUrl) => {
    // Verificar si ya está cargado
    if (document.querySelector('script[src*="tidio.co"]')) {
      console.log('Tidio ya está cargado');
      return;
    }
    
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      console.log('✅ Tidio cargado correctamente');
      setLoaded(true);
    };
    script.onerror = () => {
      console.log('❌ Error cargando Tidio');
    };
    document.body.appendChild(script);
  };

  const loadElevenLabs = (agentId) => {
    // Verificar si ya está cargado el script O si el custom element ya existe
    if (document.querySelector('script[src*="elevenlabs"]')) {
      console.log('ElevenLabs ya está cargado');
      return;
    }
    
    // Verificar si el custom element ya está registrado
    if (customElements.get('elevenlabs-convai')) {
      console.log('ElevenLabs custom element ya está registrado');
      // Solo crear el widget si no existe
      if (!document.querySelector('elevenlabs-convai')) {
        const widget = document.createElement('elevenlabs-convai');
        widget.setAttribute('agent-id', agentId);
        document.body.appendChild(widget);
      }
      return;
    }
    
    // Verificar si ya existe un widget
    if (document.querySelector('elevenlabs-convai')) {
      console.log('ElevenLabs widget ya existe');
      return;
    }
    
    // Mapeo de páginas a rutas
    const PAGE_ROUTES = {
      'dashboard': '/app/dashboard',
      'chat': '/app/chat-iba',
      'tareas': '/app/tareas',
      'calendario': '/app/calendario',
      'reuniones': '/app/reuniones-profesores',
      'materias': '/app/materias',
      'calificaciones': '/app/calificaciones',
      'perfil': '/app/perfil',
      'eventos': '/app/eventos',
      'notas': '/app/calificaciones',
      'mensajes': '/app/chat-iba',
      'inicio': '/app/dashboard',
      'home': '/app/dashboard',
      'pruebas': '/app/pruebas-examenes',
      'examenes': '/app/pruebas-examenes',
      'foro': '/app/foro',
      // Páginas nuevas agregadas
      'red de oracion': '/red-oracion',
      'oracion': '/red-oracion',
      'reunion de profesores': '/app/reuniones-profesores',
      'biblia': '/app/biblia'
    };

    // Obtener URL del API
    const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

    // Función para crear y mostrar el modal de videollamada
    const mostrarModalVideollamada = (jitsiUrl, salaId, mensaje) => {
      // Remover modal anterior si existe
      const modalAnterior = document.getElementById('videollamada-modal');
      if (modalAnterior) modalAnterior.remove();

      // Crear el modal
      const modal = document.createElement('div');
      modal.id = 'videollamada-modal';
      modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        padding: 20px;
        box-sizing: border-box;
      `;

      modal.innerHTML = `
        <div style="
          background: white;
          border-radius: 20px;
          padding: 30px;
          max-width: 400px;
          width: 100%;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3);
          animation: modalEntrada 0.3s ease;
          position: relative;
        ">
          <style>
            @keyframes modalEntrada {
              from { transform: scale(0.8); opacity: 0; }
              to { transform: scale(1); opacity: 1; }
            }
            @keyframes pulso {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.05); }
            }
          </style>
          
          <!-- Botón X para cerrar -->
          <button 
            onclick="document.getElementById('videollamada-modal').remove()"
            style="
              position: absolute;
              top: 10px;
              right: 10px;
              background: #f3f4f6;
              border: none;
              border-radius: 50%;
              width: 36px;
              height: 36px;
              font-size: 20px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #6b7280;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#e5e7eb'; this.style.color='#374151';"
            onmouseout="this.style.background='#f3f4f6'; this.style.color='#6b7280';"
          >✕</button>
          
          <div style="
            width: 80px;
            height: 80px;
            background: linear-gradient(135deg, #10b981, #059669);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 20px;
          ">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
              <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
            </svg>
          </div>
          
          <h2 style="
            margin: 0 0 10px;
            color: #1f2937;
            font-size: 24px;
            font-weight: bold;
          ">¡Sala Lista!</h2>
          
          <p style="
            color: #6b7280;
            margin: 0 0 10px;
            font-size: 14px;
          ">Sala: <strong style="color: #10b981;">${salaId}</strong></p>
          
          <p style="
            color: #6b7280;
            margin: 0 0 25px;
            font-size: 14px;
            line-height: 1.5;
          ">${mensaje || 'El Pastor Luis Rodríguez ha sido notificado y se conectará en breve.'}</p>
          
          <a 
            href="${jitsiUrl}" 
            target="_blank" 
            rel="noopener noreferrer"
            id="btn-unirse-videollamada"
            style="
              display: block;
              background: linear-gradient(135deg, #10b981, #059669);
              color: white;
              padding: 18px 30px;
              border-radius: 12px;
              font-size: 18px;
              font-weight: bold;
              text-decoration: none;
              margin-bottom: 15px;
              animation: pulso 2s infinite;
              box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
            "
          >
            📹 UNIRSE A VIDEOLLAMADA
          </a>
          
          <button 
            onclick="document.getElementById('videollamada-modal').remove()"
            style="
              background: #f3f4f6;
              border: none;
              color: #6b7280;
              font-size: 14px;
              cursor: pointer;
              padding: 10px 20px;
              border-radius: 8px;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#e5e7eb';"
            onmouseout="this.style.background='#f3f4f6';"
          >Cerrar</button>
          
          <p style="
            color: #9ca3af;
            font-size: 12px;
            margin-top: 15px;
          ">Horario de atención: 11am - 10pm (Uruguay)</p>
        </div>
      `;

      document.body.appendChild(modal);

      // Cerrar al hacer clic fuera del modal
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.remove();
        }
      });

      console.log('📹 Modal de videollamada mostrado');
    };

    // Herramientas del cliente para ElevenLabs
    const CLIENT_TOOLS = {
      navigate: ({ page }) => {
        console.log('🎤 ElevenLabs navegando a:', page);
        const route = PAGE_ROUTES[page?.toLowerCase()] || PAGE_ROUTES['dashboard'];
        window.location.href = route;
      },
      relocate: ({ page }) => {
        console.log('🎤 ElevenLabs relocate a:', page);
        const route = PAGE_ROUTES[page?.toLowerCase()] || PAGE_ROUTES['dashboard'];
        window.location.href = route;
      },
      // Nueva herramienta: Solicitar videollamada con el Pr. Luis R Rodriguez
      // OPTIMIZADA para respuesta INMEDIATA
      solicitarVideollamada: async ({ nombre, motivo }) => {
        console.log('📹 ElevenLabs solicitando videollamada:', { nombre, motivo });
        
        // Crear sala inmediatamente (no esperar al servidor)
        const salaId = `IBA-${Date.now().toString(36).toUpperCase()}`;
        const jitsiUrl = `https://8x8.vc/${salaId}`;
        
        // Mostrar modal INMEDIATAMENTE
        mostrarModalVideollamada(jitsiUrl, salaId, '¡Listo! Únete a la videollamada.');
        
        // Notificar al servidor en segundo plano (sin bloquear)
        fetch(`${API_URL}/api/public/solicitar-videollamada`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            nombre: nombre || '', 
            motivo: motivo || '',
            sala_override: salaId,
            url_override: jitsiUrl
          })
        }).catch(err => console.log('📹 Notificación en background:', err));
        
        // Cerrar ElevenLabs después de 1 segundo
        setTimeout(() => {
          try {
            const widget = document.querySelector('elevenlabs-convai');
            if (widget) {
              // Intentar cerrar de varias formas
              if (widget.endSession) widget.endSession();
              else if (widget.disconnect) widget.disconnect();
              else widget.remove();
              console.log('📹 ElevenLabs cerrado');
            }
          } catch (err) {
            console.log('📹 Error cerrando ElevenLabs:', err);
          }
        }, 1000);
        
        // Respuesta corta para que el agente termine rápido
        return {
          success: true,
          mensaje: "Listo. Presiona el botón verde. Adiós.",
          endConversation: true
        };
      },
      // Alias para videollamada
      hablarConPersona: async ({ nombre, motivo }) => {
        return CLIENT_TOOLS.solicitarVideollamada({ nombre, motivo });
      },
      llamar: async ({ nombre, motivo }) => {
        return CLIENT_TOOLS.solicitarVideollamada({ nombre, motivo });
      }
    };
    
    // Crear el elemento del widget directamente en body (sin wrapper para no afectar su tamaño)
    const widget = document.createElement('elevenlabs-convai');
    widget.setAttribute('agent-id', agentId);
    widget.id = 'elevenlabs-widget';
    document.body.appendChild(widget);

    // Agregar event listener para inyectar clientTools
    widget.addEventListener('elevenlabs-convai:call', (event) => {
      console.log('🎤 ElevenLabs call event:', event.detail);
      if (event.detail && event.detail.config) {
        event.detail.config.clientTools = CLIENT_TOOLS;
      }
    });
    
    // Luego cargar el script
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.async = true;
    script.type = 'text/javascript';
    script.onload = () => {
      console.log('✅ ElevenLabs cargado correctamente con navegación por voz');
      setLoaded(true);
      // Hacer el widget arrastrable (con reintentos por si el widget tarda en inicializarse)
      const tryMakeDraggable = (attempts) => {
        const widget = document.getElementById('elevenlabs-widget');
        if (widget) {
          makeDraggable();
        } else if (attempts > 0) {
          setTimeout(() => tryMakeDraggable(attempts - 1), 1000);
        }
      };
      setTimeout(() => tryMakeDraggable(5), 1500);
    };
    script.onerror = () => {
      console.log('❌ Error cargando ElevenLabs');
    };
    document.body.appendChild(script);
  };

  // Cleanup al desmontar
  useEffect(() => {
    return () => {
      // Limpiar Tidio si existe
      const tidioScript = document.querySelector('script[src*="tidio.co"]');
      if (tidioScript) {
        tidioScript.remove();
      }
      // Limpiar iframe de Tidio
      const tidioFrame = document.querySelector('#tidio-chat');
      if (tidioFrame) {
        tidioFrame.remove();
      }
      
      // Limpiar ElevenLabs si existe
      const elevenLabsScript = document.querySelector('script[src*="elevenlabs"]');
      if (elevenLabsScript) {
        elevenLabsScript.remove();
      }
      const elevenLabsWidget = document.querySelector('elevenlabs-convai');
      if (elevenLabsWidget) {
        elevenLabsWidget.remove();
      }
      const dragHandle = document.getElementById('elevenlabs-drag-handle');
      if (dragHandle) {
        dragHandle.remove();
      }
    };
  }, []);

  // Hacer el widget de ElevenLabs arrastrable
  const makeDraggable = () => {
    const widget = document.getElementById('elevenlabs-widget');
    if (!widget) return;

    const isMobile = window.innerWidth <= 768;

    // Crear botón de mover flotante (separado del widget, no afecta su layout)
    const moveBtn = document.createElement('div');
    moveBtn.id = 'elevenlabs-drag-handle';
    moveBtn.innerHTML = '<i class="fas fa-arrows-alt"></i>';
    moveBtn.style.cssText = `
      position: fixed;
      bottom: 90px;
      right: 12px;
      width: ${isMobile ? '42px' : '32px'};
      height: ${isMobile ? '42px' : '32px'};
      background: #1e293b;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: grab;
      color: white;
      font-size: ${isMobile ? '16px' : '13px'};
      z-index: 2147483647;
      touch-action: none;
      box-shadow: 0 2px 10px rgba(0,0,0,0.4);
      opacity: ${isMobile ? '0.8' : '0'};
      transition: opacity 0.3s, background 0.2s;
    `;
    document.body.appendChild(moveBtn);

    if (!isMobile) {
      moveBtn.addEventListener('mouseenter', () => { moveBtn.style.opacity = '1'; });
      moveBtn.addEventListener('mouseleave', () => { if (!isDragging) moveBtn.style.opacity = '0'; });
      document.addEventListener('mousemove', (e) => {
        if (isDragging) return;
        const r = moveBtn.getBoundingClientRect();
        if (Math.hypot(e.clientX - r.left - r.width/2, e.clientY - r.top - r.height/2) < 100) {
          moveBtn.style.opacity = '1';
        }
      });
    }

    let isDragging = false;
    let startX = 0, startY = 0;
    let currentTx = 0, currentTy = 0;
    let dragTx = 0, dragTy = 0;

    const saved = localStorage.getItem('el_widget_pos');
    if (saved) {
      try {
        const pos = JSON.parse(saved);
        currentTx = pos.tx || 0;
        currentTy = pos.ty || 0;
        applyTranslate();
      } catch (e) {}
    }

    function applyTranslate() {
      widget.style.transform = `translate(${currentTx}px, ${currentTy}px)`;
      moveBtn.style.transform = `translate(${currentTx}px, ${currentTy}px)`;
    }

    function startDrag(clientX, clientY, e) {
      e.preventDefault();
      e.stopPropagation();
      isDragging = true;
      moveBtn.style.cursor = 'grabbing';
      moveBtn.style.opacity = '1';
      moveBtn.style.background = '#3b82f6';
      startX = clientX;
      startY = clientY;
      dragTx = currentTx;
      dragTy = currentTy;
    }

    function moveDrag(clientX, clientY) {
      if (!isDragging) return;
      currentTx = dragTx + (clientX - startX);
      currentTy = dragTy + (clientY - startY);
      applyTranslate();
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      moveBtn.style.cursor = 'grab';
      moveBtn.style.background = '#1e293b';
      if (!isMobile) {
        setTimeout(() => { if (!isDragging) moveBtn.style.opacity = '0'; }, 2000);
      } else {
        moveBtn.style.opacity = '0.8';
      }
      localStorage.setItem('el_widget_pos', JSON.stringify({ tx: currentTx, ty: currentTy }));
    }

    moveBtn.addEventListener('mousedown', (e) => startDrag(e.clientX, e.clientY, e));
    document.addEventListener('mousemove', (e) => { if (isDragging) { e.preventDefault(); moveDrag(e.clientX, e.clientY); } });
    document.addEventListener('mouseup', endDrag);

    moveBtn.addEventListener('touchstart', (e) => {
      startDrag(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });
    document.addEventListener('touchmove', (e) => {
      if (isDragging) { e.preventDefault(); moveDrag(e.touches[0].clientX, e.touches[0].clientY); }
    }, { passive: false });
    document.addEventListener('touchend', endDrag);

    console.log('✅ Widget ElevenLabs arrastrable (sin wrapper, tamaño original)');
  };

  // Este componente no renderiza nada visible
  return null;
};

export default ChatWidgetLoader;
